import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RequestBase } from '../../../base/request-base';
import { HttpService } from '../../../services/http.service';
import { HelperService } from '../../../services/helper.service';
import { NotifyService } from '../../../services/notify.service';
import * as AppConst from '../../../data/test.data';
import { SidebarService } from '../../../sidebar/sidebar.service';
import { AuthenService } from '../../../services/authen.service';
import { SelectEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { UrlParams } from '../../../helpers/url-params';
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../../helpers/global.util';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { debug } from 'util';

@Component({
    selector: '',
    templateUrl: './request-search-checkin.html',
})
export class RequestSearchCheckinComponent extends RequestBase implements OnInit, OnDestroy {
    dateFormat: string = 'dd/MM/yyyy';
    nameValueFields: Object = { text: 'Name', value: 'Value' };
    nameValueProvinceFields: Object = { text: 'Provincename', value: 'Provincecode' };
    requestTypeMListV2: any[] = [];

    userTypeString: string = "HS";
    routeHere = "request-search-checkin";


    constructor(auth: AuthenService, http: HttpService, httpClient: HttpClient, helper: HelperService, notify: NotifyService, translate: TranslateService, router: Router, route: ActivatedRoute, private sidebar: SidebarService, @Inject('BASE_URL') public baseUrl: string) {
        super(auth, http, httpClient, helper, notify, translate, router, route, baseUrl);

        this.requestStatusDefault = "2";

        this.userTypeString = this.auth.GroupUserCode;
        this.pathCode = 1;
    }

    ngOnInit() {
        this.init();
        this.findRequestTypesV2('');
        this.sidebar.getSiteMapByUrlNew(this.auth.GroupUserCode);
        this.reBindSearchCondition();
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        if (this.subsNotify)
            this.subsNotify.unsubscribe();
    }

    onSearch() {

        if (this.requestStatusDefault != null && this.requestStatusDefault != "0")
        {
            this.requestStatusSelected = this.requestStatusDefault;
        }
        
        let params = new UrlParams();
        params.addDate('fromDate', this.fromDate);
        params.addDate('toDate', this.toDate);
        params.add('requestTypes', Util.array2String1(this.requestTypesSelected, ';'), '');
        params.add('requestStatus', this.requestStatusSelected, '');
        params.add('custSearch', this.keywordCustomerSearch, '');
        params.add('scSearch', this.keywordSCSearch, '');
        params.add('requestCode', this.requestCodeSearch, '');
        params.add('userName', this.auth.LoginUser, '');
        params.add('userType', this.auth.GroupUserCode, '');
        params.add('area', Util.array2String1(this.areaSelected, ','), '');
        params.add('province', this.provinceSearch, '');
        let APILink: string = "";
        if (this.auth.GroupUserCode == "HS")
        {
            APILink = `api/HsMatrixV2/SearchRequestHSV2/${params.toString()}`;

        } else if (this.auth.GroupUserCode == "SC")
        {
            APILink = `api/BCMatrixV2/SearchRequestBCV2/${params.toString()}`;

        } else if (this.auth.GroupUserCode == "FFM")
        {
            let ffmConfirm = "";
            if (this.requestStatusSelected == "0"
                || this.requestStatusSelected == null
                || this.requestStatusSelected == undefined) {
                ffmConfirm = "";
            } else if (this.requestStatusSelected == "9") {
                ffmConfirm = "N";
            } else {
                ffmConfirm = "A";
            }

            

            params.add('ffmConfirm', ffmConfirm, '');
            APILink = `api/FFMMatrixV2/SearchRequestFFMV2/${params.toString()}`;
        }


        this.data = this.http.getByManager(APILink, this.auth);
 



    }

    onClearSearch() {
        this.requestStatusSelected = this.requestStatusDefault;
        //this.requestTypeSelected = null;
        this.fromDate = null;
        this.toDate = null;
        this.keywordCustomerSearch = null;
        this.keywordSCSearch = null;
        this.requestCodeSearch = null;
        this.requestTypesSelected = [];
        this.areaSelected = [];
        this.checkAreaMList = false;
        this.checkRequestTypeMList = false;
        

        this.provinceSearch = "";


        let searchConditions = localStorage.getItem('SearchTerm');
        if (searchConditions != null && searchConditions != undefined) {
            let objectSearch = JSON.parse(searchConditions);
            let newSearchList = objectSearch.filter(x => x.route !== this.routeHere);
            localStorage.setItem('SearchTerm', JSON.stringify(newSearchList));

        } this.onSearch();


        

    }


    findRequestTypesV2(text: string) {
        this.http.get(`api/Util/GetRequestTypeListV2?userName=${this.auth.LoginUser}&userType=${this.auth.GroupUserCode}&text=${text}`, res => {
            let tempListV2 = [];
            res.Result.forEach(p => tempListV2.push({ 'Name': p.Name, 'Value': p.Value }));
            this.requestTypeMListV2 = tempListV2;
        });
    }




    onCheckAllRequestType(evt: ChangeEventArgs) {
        this.enableRequestTypeList = true;//!evt.checked;

        if (evt.checked) {
            this.requestTypesSelected = [];
            this.checkRequestTypeMList = true;
            this.requestTypeMListV2.forEach(p => {
                this.requestTypesSelected.push(p.Value);
            });
        } else {
            this.requestTypesSelected = [];
            this.checkRequestTypeMList = false;
        }
        //this.ngRefresh();
    }

    onCheckAllArea(evt: ChangeEventArgs) {
        this.enableAreaList = true;//!evt.checked;

        if (evt.checked) {
            this.areaSelected = [];
            this.checkAreaMList = true;
            this.areaMList.forEach(p => {
                this.areaSelected.push(p);
            });
        } else {
            this.areaSelected = [];
            this.checkAreaMList = false;
        }

        this.getProvinceDDL(null);
    }


   


    



    onActionBegin(evt: any) {
    }

}

